import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ConfigModel } from '../../models/config-model.model';
import { ConfigService } from '../../services/config.service';
import { CameraService } from '../../services/camera.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { User } from '../../models/user.model';
import { AuthService } from '../../services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FileUploader } from 'ng2-file-upload';

@Component({
  selector: 'app-config-edit',
  templateUrl: './config-edit.component.html',
  styleUrls: ['./config-edit.component.css']
})
export class ConfigEditComponent implements OnInit {

  public fbAuthNumber = null;
  @ViewChild('modal') protected modal: ElementRef;

  public availableCameras = [];
  public selectedCamera = [];

  public isEdit = false;

  public config = new ConfigModel({});
  public errors: any = {};

  constructor(
    private router: Router,
    protected route: ActivatedRoute,
    protected configService: ConfigService,
    protected cameraService: CameraService,
    protected authService: AuthService,
    protected modalService: NgbModal
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe(route => {
      this.cameraService.index().subscribe(cameras => {
        this.availableCameras = cameras;

        if (route['_id']) {
          this.isEdit = true;
          this.configService.show(route['_id']).subscribe(config => {
            this.config = config;
          });
        }
      });
    });
  }

  submit() {
    this.save()
  }

  save() {
    if (!this.isEdit) {
      delete(this.config._id)
    }
    this.configService.updateOrStore(this.config, this.isEdit).subscribe(result => {
      return this.router.navigate(['/config']);
    }, errors => {
      this.errors = errors;
      console.log(errors);
    });
  }

}



// WEBPACK FOOTER //
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/components/config-edit/config-edit.component.ts